<script lang="ts" setup>
import { Statistics } from '@/models/statistics.model';
import statisticsService from '@/services/statistics.service';

import { onMounted, ref } from 'vue';

const data = ref<Statistics[]>([]);
const data2 = ref<Statistics[]>([]);

onMounted(async () => {
  const d = await statisticsService.getQuizzesStartedFinished();
  data.value = d;
  const d2 = await statisticsService.getQuizzesPerDay();
  data2.value = d2;
});
</script>
<template>
  <v-container>
    <h2>Quiz Of The Day interaction</h2>
    <p>
      This shows the amount of quizzes of the day over the last 30 days where
      people "Started" and "Finished" the quiz.
    </p>
    <v-frappe-chart
      type="bar"
      :labels="data.map((d) => d.label)"
      :data="[
        {
          name: data[0]?.stackedValues[0].label || '',
          values: data.map((d) => d.stackedValues[0].value),
        },
        {
          name: data[0]?.stackedValues[1].label || '',
          values: data.map((d) => d.stackedValues[1].value),
        },

        {
          name: data[0]?.stackedValues[2].label || '',
          values: data.map((d) => d.stackedValues[2].value),
        },
      ]"
      :height="480"
      :colors="['red', 'orange', '#ff570a']"
    />
    <h2>Presented, Opened, and Completed quizzes</h2>
    <p>
      This shows the amount of quizzes of the day over the last 30 days where
      people were "Presented" with, "Watched" and "Completed" their quiz.
    </p>
    <v-frappe-chart
      type="line"
      :labels="data2.map((d) => d.label)"
      :data="[
        {
          name: data2[0]?.stackedValues[0].label || '',
          values: data2.map((d) => d.stackedValues[0].value),
        },
        {
          name: data2[0]?.stackedValues[1].label || '',
          values: data2.map((d) => d.stackedValues[1].value),
        },

        {
          name: data2[0]?.stackedValues[2].label || '',
          values: data2.map((d) => d.stackedValues[2].value),
        },
      ]"
      :height="480"
      :colors="['red', 'green', 'blue']"
    />
  </v-container>
</template>
